<template >
	<v-content v-if="$store.state.loaded">
			<v-row  align="center" justify="center">
				<v-col cols="12">
						<v-card class="mx-auto" max-width="600">
								<v-img src="/static/images/403.gif"/>
							<v-card-text>
								<div class="red--text">Algo no anda bien con su cuenta</div>
								<p class="display-1 text--primary">
									Uebs App Lab
								</p>
								<p>Puedes contactarnos en info@uebs.net</p>
								<div class="text--primary">
									Menú QR  es la mejor opción para su Negocio o emprendimiento.
								</div>
							</v-card-text>
						</v-card>
				</v-col>
			</v-row>
	</v-content>
	<v-container v-else fill-height>
			<v-layout flex align-center justify-center>
				<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
			</v-layout>
		</v-container>
</template>

<script>
	export default {
		name: 'OverDueBilling'
		
	}
</script>

<style>

</style>